var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9A8D4",
    d: "m10.833 15-4.166 2.5V15H5a2.5 2.5 0 0 1-2.5-2.5V5.834a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v3.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A8D4",
    d: "m10.833 15-4.166 2.5V15H5a2.5 2.5 0 0 1-2.5-2.5V5.834a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5V15z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F9A8D4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m10.833 15-4.166 2.5V15H5a2.5 2.5 0 0 1-2.5-2.5V5.834a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5V15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB2777",
    d: "M16.7 14.167a.868.868 0 1 0-1.736 0 .868.868 0 0 0 1.736 0m1.6 0a2.467 2.467 0 1 1-4.935-.001 2.467 2.467 0 0 1 4.935.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB2777",
    d: "M16.7 14.167a.868.868 0 1 0-1.736 0 .868.868 0 0 0 1.736 0m.834 4.167a.87.87 0 0 0-.867-.868H15a.87.87 0 0 0-.867.867.8.8 0 0 1-1.6 0 2.467 2.467 0 0 1 2.468-2.466h1.665a2.466 2.466 0 0 1 2.467 2.467.8.8 0 0 1-1.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB2777",
    d: "M17.534 18.334a.87.87 0 0 0-.867-.868H15a.87.87 0 0 0-.867.867.8.8 0 0 1-.8.8h5a.8.8 0 0 1-.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.578 12.423a2.47 2.47 0 0 1-.099 3.582 2.47 2.47 0 0 1 1.654 2.329.8.8 0 0 1-.8.8h-1.61c.293.592.904 1 1.61 1l.184-.01a1.8 1.8 0 0 0 1.616-1.79 3.47 3.47 0 0 0-1.197-2.62c.213-.426.337-.894.36-1.375l.005-.172c0-.862-.322-1.69-.897-2.326l-.119-.125a3.47 3.47 0 0 0-2.28-1.012l-.171-.004a3.466 3.466 0 0 0-3.467 3.467l.004.172c.024.481.148.949.36 1.374q-.093.08-.182.17a3.47 3.47 0 0 0-1.015 2.45l.01.185a1.8 1.8 0 0 0 1.79 1.616l.183-.01a1.8 1.8 0 0 0 1.427-.99h-1.61a.8.8 0 0 1-.8-.8 2.47 2.47 0 0 1 1.654-2.33l-.098-.093a2.47 2.47 0 0 1 0-3.488 2.467 2.467 0 0 1 3.488 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgUser;